function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2.667H1.333C.597 2.667 0 3.263 0 4v6.667C0 11.403.597 12 1.333 12H12c.737 0 1.333-.597 1.333-1.333V4c0-.737-.596-1.333-1.333-1.333zm0 8H1.333V4H12v6.667zM10 0H3.333C2.597 0 2 .597 2 1.333h9.333C11.333.597 10.737 0 10 0z",
  fill: "#000"
}));